import React, { useContext } from "react";
import { ModalContext } from "./types.js";
const BulkModalContext = React.createContext(void 0);
const BulkModalProvider = ({ children }) => {
  const { openModal, closeModal } = useContext(ModalContext);
  const chooseStep = (step, onClose, stepWidth) => {
    openModal({ body: step, styleParams: { maxWidth: stepWidth }, onClose });
  };
  return /* @__PURE__ */ React.createElement(BulkModalContext.Provider, { value: { chooseStep, closeModal } }, children);
};
export {
  BulkModalContext,
  BulkModalProvider
};
//# sourceMappingURL=BulkModalProvider.js.map
